import React, { useState, useEffect, useRef } from 'react';
import agent from 'superagent';
import Notification from './Notification.jsx';
import { useLocation, matchPath } from 'react-router-dom';
import useBrowserTabActive from 'hooks/useBrowserTabActive/index.js';
import { trackingService } from 'services/tracking/TrackingService.js';
import * as ROUTES from 'constants/routes.js';

const indexHtmlFile = `${window.location.origin}/index.html`;

const getLastUpdatedTimestamp = async (url) => {
  let timestamp = null;
  try {
    const { header } = await agent.head(url);
    Object.keys(header).forEach(key => {
      if (key.toLowerCase() === 'last-modified') {
        timestamp = new Date(header[key]);
      }
    });
  } catch (err) {
    console.log(err);
  }
  return timestamp;
};

const excludedRoutesCheck = [
  ROUTES.ORG_AGENT_TOOL,
];

const isExcludedRoute = pathname => {
  for (const route of excludedRoutesCheck) {
    if (matchPath(pathname, { path: route })?.isExact) {
      return true;
    }
  }

  return false;
};

const NewVersionAlertWrapper = ({ children }) => {
  const location = useLocation();
  const { isBrowserTabActive } = useBrowserTabActive();
  const [hasNewVersion, setHasNewVersion] = useState(false);
  const [prevBundleUpdatedAt, setPrevBundleUpdatedAt] = useState(null);
  const [hideNotification, setHideNotification] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    const checkNewVersion = async () => {
      if (!hasNewVersion) {
        const bundleUpdatedAt = await getLastUpdatedTimestamp(indexHtmlFile);
        if (prevBundleUpdatedAt?.getTime() < bundleUpdatedAt?.getTime() && !isExcludedRoute(location.pathname)) {
          setHasNewVersion(true);
        } else {
          timer.current = setTimeout(checkNewVersion, 300 * 1000); // 5 min
        }

        if (!prevBundleUpdatedAt) {
          setPrevBundleUpdatedAt(bundleUpdatedAt);
        }
      }
    };

    timer.current = setTimeout(checkNewVersion, 0);

    return () => {
      clearTimeout(timer.current);
    };
  }, [hasNewVersion, prevBundleUpdatedAt]);

  useEffect(() => {
    if (hasNewVersion) {
      window.location.reload();
    }
    // Do not add hasNewVersion as a dependency, as i only want a reload on location change
    // eslint-disable-next-line
  }, [location.key]);

  useEffect(() => {
    const checkVersion = async () => {
      const bundleUpdatedAt = await getLastUpdatedTimestamp(indexHtmlFile);

      if (prevBundleUpdatedAt?.getTime() < bundleUpdatedAt?.getTime() && !isExcludedRoute(location.pathname)) {
        setHasNewVersion(true);
      }
    };

    if (isBrowserTabActive) {
      checkVersion();
    }
    // I do not wanna trigger on prevBundleUpdatedAt
    // eslint-disable-next-line
  }, [isBrowserTabActive]);

  useEffect(() => {
    if (hasNewVersion) {
      trackingService.track({
        eventType: 'app:new-version',
      });
    }
  }, [hasNewVersion]);

  return (
    <>
      {(hasNewVersion && !hideNotification) ? <Notification cancel={setHideNotification} /> : null}
      {children}
    </>
  );
};

export default NewVersionAlertWrapper;
